import { useState } from 'react';

import { Popover } from '@air/primitive-popover';
import { Tooltip } from '@air/primitive-tooltip';

import { getTableColumnWidth } from '../utils/getTableColumnWidth';
import { RecentlyDeletedTableCell } from './RecentlyDeletedTableCell';

type Props = { deletedFrom?: { title: string; id: string }[] };

export const RecentlyDeletedTableCellDeletedFrom = ({ deletedFrom }: Props) => {
  const [open, setOpen] = useState(false);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  if (!deletedFrom || !deletedFrom.length) {
    return <RecentlyDeletedTableCell width={getTableColumnWidth('deletedFrom')}>--</RecentlyDeletedTableCell>;
  }

  if (deletedFrom.length === 1) {
    return (
      <RecentlyDeletedTableCell width={getTableColumnWidth('deletedFrom')}>
        <Tooltip label={deletedFrom[0].title} side="top" sideOffset={4} align="start">
          <span className="truncate">{deletedFrom[0].title}</span>
        </Tooltip>
      </RecentlyDeletedTableCell>
    );
  }

  return (
    <RecentlyDeletedTableCell width={getTableColumnWidth('deletedFrom')}>
      <Popover
        trigger={
          <span onMouseOver={handleMouseEnter} onMouseOut={handleMouseLeave}>
            {deletedFrom.length} boards
          </span>
        }
        open={open}
        onOpenChange={setOpen}
      >
        {deletedFrom.map((from) => (
          <div className="p-2 text-14 text-grey-12" key={from.id}>
            {from.title}
          </div>
        ))}
      </Popover>
    </RecentlyDeletedTableCell>
  );
};
